import React from 'react';
import { TaxReliefElegibleType } from 'further-types/exit';
import AppRadioButton from 'components/FormElements/AppRadioButton';
import {
  renderTaxReliefButton,
  type TaxReliefButtonRendererProps,
} from '../helpers/getTaxReliefTooltip';

const TAX_RELIEF_CONFIG = {
  [TaxReliefElegibleType.Yes]: { label: 'Yes', numericValue: 1 },
  [TaxReliefElegibleType.No]: { label: 'No', numericValue: 0 },
  [TaxReliefElegibleType.Partial]: { label: 'Partial', numericValue: 2 },
} as const;

type TaxReliefButtonProps = {
  option: TaxReliefElegibleType;
  checked: boolean;
  onChange: (value: TaxReliefElegibleType) => void;
  error?: boolean;
  disableEdit: boolean;
  isEntireFieldDisabled: boolean;
  isYesDisabled: boolean;
  isNoDisabled: boolean;
  isPartialDisabled: boolean;
  originalTaxReliefElegible?: TaxReliefElegibleType;
};

const TaxReliefButton: React.FC<TaxReliefButtonProps> = ({
  option,
  checked,
  onChange,
  error = false,
  disableEdit,
  isEntireFieldDisabled,
  isYesDisabled,
  isNoDisabled,
  isPartialDisabled,
  originalTaxReliefElegible,
}): React.ReactElement => {
  const rendererProps: TaxReliefButtonRendererProps = {
    disableEdit,
    isEntireFieldDisabled,
    isYesDisabled,
    isNoDisabled,
    isPartialDisabled,
    originalTaxReliefElegible,
  };

  const config = TAX_RELIEF_CONFIG[option];

  const isDisabledForOption =
    (option === TaxReliefElegibleType.Yes && isYesDisabled) ||
    (option === TaxReliefElegibleType.No && isNoDisabled) ||
    (option === TaxReliefElegibleType.Partial && isPartialDisabled);

  const button = (
    <AppRadioButton
      name="taxReliefElegible"
      label={config.label}
      value={config.numericValue}
      checked={checked}
      onChange={(_, isChecked) => {
        if (isChecked) {
          onChange(option);
        }
      }}
      error={error}
      disabled={disableEdit || isEntireFieldDisabled || isDisabledForOption}
    />
  );

  return renderTaxReliefButton(option, button, rendererProps);
};

export default TaxReliefButton;
